module.exports = __webpack_public_path__ + "KaTeX_Typewriter-Regular.e6d44b61.ttf";